module.exports = __webpack_public_path__ + "img/ic_12_flame_white.ceb52594.svg";